import { PrimaryInfo } from './../util';
import { WorkingGroup } from './../../models/WorkingGroup';

export const getSuggestion = (wg: WorkingGroup): PrimaryInfo => {
    return {
        name: wg.name,
        id: wg.id
    };
};
